import React from 'react';

import CaregiverListScene from '../../list/CaregiverListScene';

import {generateLoomFilterOptions} from './LoomFilterGenerator';

import backend from 'utils/backend';

const filterOptions = generateLoomFilterOptions();
const formatLanguageFilter = (labels) => labels;

// The list scene keys and opens each row by `caregiverRn`. The Loom caregiver page opens by Loom
// id, and a Loom caregiver may have no legacy RN, so the list rows carry the Loom id there.
const caregiverApi = {
  queryCaregiver: async (filter, sortBy, cursor) => {
    const result = await backend.loom.caregiver.queryCaregiver(filter, sortBy, cursor);
    return {
      ...result,
      list: result.list.map((caregiver) => ({...caregiver, caregiverRn: caregiver.caregiverId})),
    };
  },
};

const LoomCaregiverList = (props) => {
  return (
    <CaregiverListScene
      {...props}
      caregiverApi={caregiverApi}
      caregiverDetailBasePath='/caregiver-loom'
      filterOptions={filterOptions}
      formatLanguageFilter={formatLanguageFilter}
      showMapFilter={false}
      statusTranslationKey='caregiver.LoomStatus'
      titleExpression='caregiver.CaregiverList.LoomTitle'
    />
  );
};

export default React.memo(LoomCaregiverList);
